"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderIslands = exports.hydrateIslands = void 0;
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var Providers = function (_a) {
    var providers = _a.providers, children = _a.children;
    return providers
        .reverse()
        .reduce(function (acc, Provider) { return react_1.default.createElement(Provider, null, acc); }, children);
};
var getIsland = function (island, name) {
    var Component = typeof island === 'object' ? island.Component : island;
    if (!Component) {
        console.warn("Found a server-rendered Island for ".concat(name, " but no matching component"));
        return;
    }
    var Provider = typeof island === 'object'
        ? island.Provider
        : function (_a) {
            var children = _a.children;
            return react_1.default.createElement(react_1.default.Fragment, null, children);
        };
    return {
        Component: Component,
        Provider: Provider,
    };
};
var getIslands = function (islands, identifier, providers) {
    return Array.from(document.querySelectorAll("[data-island-".concat(identifier, "-component]")))
        .map(function (island) {
        var name = island.getAttribute("data-island-".concat(identifier, "-component")) || '';
        if (!name) {
            return;
        }
        if (process.env.NODE_ENV !== 'development') {
            island.removeAttribute("data-island-".concat(identifier, "-component"));
        }
        var _a = getIsland(islands[name], name), Component = _a.Component, Provider = _a.Provider;
        if (!Component) {
            return;
        }
        var props = JSON.parse(island.getAttribute("data-island-".concat(identifier, "-props")) || '{}');
        island.removeAttribute("data-island-".concat(identifier, "-props"));
        return {
            island: island,
            IslandComponent: function () { return (react_1.default.createElement(Providers, { providers: __spreadArray(__spreadArray([], providers, true), [Provider], false) },
                react_1.default.createElement(Component, __assign({}, props)))); },
        };
    })
        .filter(Boolean);
};
var hydrateIslands = function (islands, providers) {
    if (providers === void 0) { providers = []; }
    getIslands(islands, 'hydrate', providers).forEach(function (_a) {
        var island = _a.island, IslandComponent = _a.IslandComponent;
        (0, client_1.hydrateRoot)(island, react_1.default.createElement(IslandComponent, null));
    });
};
exports.hydrateIslands = hydrateIslands;
var renderIslands = function (islands, providers) {
    if (providers === void 0) { providers = []; }
    getIslands(islands, 'render', providers).forEach(function (_a) {
        var island = _a.island, IslandComponent = _a.IslandComponent;
        (0, client_1.createRoot)(island).render(react_1.default.createElement(IslandComponent, null));
    });
};
exports.renderIslands = renderIslands;
//# sourceMappingURL=utils.js.map